import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Row, Col, Card, Table, Badge, Spinner, Pagination, Button } from 'react-bootstrap';
import { LuFileText, LuDownload, LuChevronRight, LuCalendar } from "react-icons/lu";
import PortalAxios, { baseURL } from '../../services/PortalAxios';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { formatCurrency } from '../../utils/currency';

const PortalInvoices = () => {
    const navigate = useNavigate();
    const { businessId } = useParams();
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({ page: 1, pages: 1 });
    const currency = useSelector((state) => state.portalAuth?.businessData?.jssettings?.currency || 'CAD');

    const fetchInvoices = async (page = 1) => {
        setLoading(true);
        try {
            const res = await PortalAxios.PortalRequest({
                method: 'get',
                url: `${baseURL}/portal/invoices?page=${page}&limit=10`
            });
            setInvoices(res.data.data.list);
            setPagination(res.data.data.pagination);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvoices();
    }, []);

    const getStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case "paid":
                return <Badge bg="success-subtle" className="text-success rounded-pill px-3">Paid</Badge>;
            case "sent":
                return <Badge bg="info-subtle" className="text-info rounded-pill px-3">Sent</Badge>;
            case "draft":
                return <Badge bg="warning-subtle" className="text-warning rounded-pill px-3">Draft</Badge>;
            case "cancelled":
                return <Badge bg="danger-subtle" className="text-danger rounded-pill px-3">Cancelled</Badge>;
            default:
                return <Badge bg="secondary-subtle" className="text-secondary rounded-pill px-3">{status}</Badge>;
        }
    };
    return (
        <div>
            <div className="mb-4">
                <h2 className="fw-bold text-dark mb-1">My Invoices</h2>
                <p className="text-muted mb-0">View and download your billing history.</p>
            </div>

            <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
                <Card.Body className="p-0">
                    {loading ? (
                        <div className="text-center py-5"><Spinner animation="border" style={{ color: "#28B0C4" }} /></div>
                    ) : invoices.length > 0 ? (
                        <div className="table-responsive">
                            <Table hover className="align-middle mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="ps-4 py-3 text-muted small fw-bold">INVOICE #</th>
                                        <th className="py-3 text-muted small fw-bold">DATE</th>
                                        <th className="py-3 text-muted small fw-bold">DUE DATE</th>
                                        <th className="py-3 text-muted small fw-bold">AMOUNT</th>
                                        <th className="py-3 text-muted small fw-bold">STATUS</th>
                                        <th className="pe-4 py-3"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoices.map((inv) => {
                                        // const colors = getStatusColor(inv.status);
                                        return (
                                            <tr key={inv._id} className="cursor-pointer" onClick={() => navigate(`/customer-side/${businessId}/invoices/${inv._id}`)}>
                                                <td className="ps-4 py-3 fw-bold text-dark">
                                                    #{inv._id.slice(-8).toUpperCase()}
                                                </td>
                                                <td className="py-3 text-muted small">
                                                    {moment(inv.invoiceDate).format('MMM D, YYYY')}
                                                </td>
                                                <td className="py-3 text-muted small">
                                                    {moment(inv.invoiceDueDate).format('MMM D, YYYY')}
                                                </td>
                                                <td className="py-3 fw-bold text-dark">
                                                    {formatCurrency(inv.totalAmount, currency)}
                                                </td>
                                                <td>{getStatusBadge(inv?.status)}</td>
                                                <td className="pe-4 py-3 text-end">
                                                    <LuChevronRight size={18} className="text-muted" />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <LuFileText size={48} className="text-muted opacity-25 mb-3" />
                            <h5 className="text-muted">No invoices found</h5>
                        </div>
                    )}
                </Card.Body>
            </Card>

            {pagination.pages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                    <Pagination>
                        <Pagination.Prev disabled={pagination.page === 1} onClick={() => fetchInvoices(pagination.page - 1)} />
                        {[...Array(pagination.pages)].map((_, i) => (
                            <Pagination.Item
                                key={i + 1}
                                active={i + 1 === pagination.page}
                                onClick={() => fetchInvoices(i + 1)}
                                style={{ '--bs-pagination-active-bg': '#28B0C4', '--bs-pagination-active-border-color': '#28B0C4' }}
                            >
                                {i + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next disabled={pagination.page === pagination.pages} onClick={() => fetchInvoices(pagination.page + 1)} />
                    </Pagination>
                </div>
            )}
        </div>
    );
};

export default PortalInvoices;
